import { defineStore } from 'pinia'
import axios from './api'
import type { Branch } from '@/types/branch.type'
import { createDiscreteApi } from 'naive-ui'

const { message } = createDiscreteApi(['message'])

interface State {
  branches: Branch[]
  currentBranch: Branch | null // router.paramsに反映されている現店舗
}

export const useBranchStore = defineStore('branchStore', {
  state: (): State => ({
    branches: [],
    currentBranch: null,
  }),
  getters: {
    get_current_branch(state): Branch {
      // 各viewから呼び出す（resolve currentBranchはrouterで保証されている）
      if (!state.currentBranch) {
        throw new Error('Missing: Current branch.')
      }
      return state.currentBranch
    },
    defaultBranch(state): Branch | undefined {
      if (state.branches.length === 0) return undefined
      return state.branches.reduce((min, b) => (b.id < min.id ? b : min), state.branches[0])
    },
    canCheckout(state): boolean {
      return !!state.currentBranch && !state.currentBranch.suspendMobileOrderCheckout
    },
  },
  actions: {
    existsCurrentBranch(code: string) {
      if (this.currentBranch?.code === code) {
        return true
      }
      const found = this.branches.find((b) => b.code === code)
      if (found) {
        this.$patch((state) => {
          state.currentBranch = found
        })
        return true
      }
      return false
    },
    clearBranches() {
      this.$patch((state) => {
        state.branches = []
      })
    },
    clearCurrentBranch() {
      this.$patch((state) => {
        state.currentBranch = null
      })
    },
    getBranches() {
      return new Promise<void>((resolve, reject) => {
        axios
          .get<Branch[]>('/branches')
          .then((res) => {
            this.$patch((state) => {
              state.branches = res.data
            })
            resolve()
          })
          .catch((err) => {
            message.error('店舗一覧の取得に失敗しました。')
            console.error('Failed to fetch branches:', err)
            reject(err)
          })
      })
    },
  },
})
